import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { compose } from "recompose";
import { withStyles, Paper, Typography } from '@material-ui/core';
import t from "../../../../languages/pl";
import Reminder from './Reminder';
import withSaveButton from './../../../HOC/withSaveButton';
import { technicalInspectionReminder, insuranceReminder, longLayoverReminder } from "../../../../utils/staticData";

const useStyles = theme => ({
    paper: {
        margin: theme.spacing(1),
        padding: theme.spacing(2),
        height: 460,
        maxHeight: 460,
    },
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: theme.spacing(2)
    },
    section: {

    }
});

const Reminders = props => {
    const { classes, data, onChange } = props;
    const [internalState, setInternalState] = useState(data);

    useEffect(() => {
        setInternalState(data);
        props.onFormDataChange(data);
    }, [data]);

    useEffect(() => {
        props.onFormDataChange(internalState);
        onChange && onChange(internalState);
    }, [internalState]);

    const handleChange = (sectionName, name, value) => {
        setInternalState(prevState => ({
            ...prevState,
            [sectionName]: {
                ...prevState[sectionName],
                [name]: value
            }
        }));
    };

    return (
        <Paper
            square
            className={classes.paper}
        >
            <Typography variant="subtitle1">
                {t.reminders}
            </Typography>
            <div className={classes.container}>
                <Reminder
                    title={t.aboutTechnicalInspection}
                    before={'before'}
                    value1={internalState[technicalInspectionReminder].przypomnienie1}
                    onChange1={(value) => handleChange(technicalInspectionReminder, "przypomnienie1", value)}
                    value2={internalState[technicalInspectionReminder].przypomnienie2}
                    onChange2={(value) => handleChange(technicalInspectionReminder, "przypomnienie2", value)}
                />
                <Reminder
                    title={t.aboutInsurance}
                    before={'before'}
                    value1={internalState[insuranceReminder].przypomnienie1}
                    onChange1={(value) => handleChange(insuranceReminder, "przypomnienie1", value)}
                    value2={internalState[insuranceReminder].przypomnienie2}
                    onChange2={(value) => handleChange(insuranceReminder, "przypomnienie2", value)}
                />
                <Reminder
                    title={t.aboutToLongLayover}
                    value1={internalState[longLayoverReminder].przypomnienie1}
                    onChange1={(value) => handleChange(longLayoverReminder, "przypomnienie1", value)}
                    value2={internalState[longLayoverReminder].przypomnienie2}
                    onChange2={(value) => handleChange(longLayoverReminder, "przypomnienie2", value)}
                />
            </div>
        </Paper>
    );
};

const mapStateToProps = state => ({
    data: state.settingsReducer.reminders
});

Reminders.propTypes = {
    classes: PropTypes.object,
    onChange: PropTypes.func,
    //redux
    data: PropTypes.object,
    //withSaveButton
    onFormDataChange: PropTypes.func
};

export default compose(
    withStyles(useStyles),
    connect(
        mapStateToProps
    ),
    withSaveButton
)(Reminders);
